import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_INPUT_GIFT_BANNER} from "../../utils/input-field-list-static-page";
import {setWaste4ChangeErrorMessage, setWaste4ChangeGiftBannerDetail} from "../../reducers/waste-4-change.reducer";
import React, {useEffect} from "react";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const GiftBanner = () => {
    const dispatch = useDispatch()
    const {giftBannerDetail, waste4ChangeErrorMessage} = useSelector(state => state.waste4ChangeReducer)
    const {fetching: getGiftBanner} = useFetch(API.W4C_GET_GIFT_BANNER)
    const {fetching: updateGiftBanner, isLoading} = useFetch(API.W4C_UPDATE_GIFT_BANNER)
    let fieldListInput = FIELD_LIST_INPUT_GIFT_BANNER
    let showGiftBanner = {
        label: 'Gift Banner',
        key: 'show_gift_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setWaste4ChangeGiftBannerDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateGiftBanner(giftBannerDetail).then(response => {
            dispatch(setWaste4ChangeErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Gift Banner Updated'))
            dispatch(setWaste4ChangeGiftBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setWaste4ChangeErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getGiftBanner().then(response => {
            dispatch(setWaste4ChangeGiftBannerDetail(response?.data))
        })

        return () => {
            dispatch(setWaste4ChangeErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={giftBannerDetail}
            switchToggleField={showGiftBanner}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={waste4ChangeErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default GiftBanner